import EventIcon from '@mui/icons-material/Event';
import { IconButton } from '@mui/material';
import { DateRangePicker as DateRangePickerMui, SingleInputDateRangeField } from '@mui/x-date-pickers-pro';
import { formatISO, isValid, parseISO } from 'date-fns';
import React from 'react';
export const DateRangePicker = (props) => {
    var _a;
    const [focused, setFocused] = React.useState(false);
    const [value, setValue] = React.useState([
        props.value.from ? parseISO(props.value.from) : null,
        props.value.to ? parseISO(props.value.to) : null,
    ]);
    const hasValue = !!props.value.from || !!props.value.to;
    const handleChange = (newValue) => {
        setValue(newValue);
        props.onChange({
            from: newValue[0] && isValid(newValue[0]) ? formatISO(newValue[0], { representation: 'date' }) : undefined,
            to: newValue[1] && isValid(newValue[1]) ? formatISO(newValue[1], { representation: 'date' }) : undefined,
        });
    };
    const parsedValue = [
        props.value.from ? parseISO(props.value.from) : value[0],
        props.value.to ? parseISO(props.value.to) : value[1],
    ];
    return (React.createElement(DateRangePickerMui, { slots: { field: SingleInputDateRangeField }, slotProps: {
            textField: {
                onFocus: () => {
                    setFocused(true);
                },
                onBlur: () => {
                    setFocused(false);
                },
                tabIndex: props.tabIndex,
                required: props.required,
                error: props.error,
                InputLabelProps: !props.hideLabel ? undefined : { shrink: false },
                inputProps: { 'aria-label': props.label, 'aria-describedby': props.ariaDescribedBy },
                InputProps: {
                    endAdornment: (React.createElement(IconButton, { "aria-label": props.label },
                        React.createElement(EventIcon, null))),
                    sx: {
                        paddingRight: 0,
                    },
                },
            },
        }, value: parsedValue, onChange: handleChange, label: (hasValue || focused) && props.hideLabel ? '' : props.label, sx: [
            {
                width: props.fullWidth ? '100%' : 260,
                '& label.MuiInputLabel-root': { paddingRight: 3 },
            },
            ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
        ], disabled: props.disabled, readOnly: props.readOnly, autoFocus: (_a = props.autoFocus) !== null && _a !== void 0 ? _a : false, maxDate: props.maxDate ? parseISO(props.maxDate) : undefined, minDate: props.minDate ? parseISO(props.minDate) : undefined }));
};
